import { forwardRef } from 'react'
import FlexRoot, { Props, Ref } from './Flex'

function Flex(props: Props, ref?: Ref) {
  return <FlexRoot {...props} ref={ref} />
}

export type { Props }
export default forwardRef(Flex)
